// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate } from "react-router-dom";

// const AddNiosNotes = () => {
//   const [schoolClassName, setSchoolClassName] = useState([]);
//   const [schoolClassNameId, setSchoolClassNameId] = useState("");
//   const [subjects, setSubjects] = useState([]);
//   const [subjectId, setSubjectId] = useState("");
//   const [noteTitle, setNoteTitle] = useState("");
//   const [file, setFile] = useState(null); // Capture the actual file object
//   const [language, setLanguage] = useState("");

//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
//   const navigate = useNavigate();

//   // Fetch the class names
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/niosClasses`)
//       .then((resp) => {
//         const { data } = resp;
//         // console.log(resp.data);
//         console.log(data);

//         setSchoolClassName(data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, []);

//   // Fetch subjects based on selected class name
//   useEffect(() => {
//     if (schoolClassNameId) {
//       axios
//         .get(`${API_BASE_URL}/niosSubjects?classId=${schoolClassNameId}`)
//         .then((result) => {
//           const { data } = result;
//           setSubjects(data);
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//   }, [schoolClassNameId]);

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Create FormData to handle file and other data
//     const formData = new FormData();
//     formData.append("noteTitle", noteTitle);
//     formData.append("language", language);
//     formData.append("niosSubjectId", subjectId); // Set as subjectId
//     formData.append("noteFile", file); // Append file

//     // POST request to /notes
//     axios
//       .post(`${API_BASE_URL}/admin/notes`, formData, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((response) => {
//         alert("Nios Note added successfully!");
//         navigate("/upload-notes/all-nios-notes"); // Navigate after success
//       })
//       .catch((error) => {
//         console.error("Error adding note:", error);
//         alert("There was an error adding the note.");
//       });
//   };

//   // Navigation handlers
//   const handleAddNewNote = () => {
//     navigate("/upload-notes/add-nios-notes");
//   };

//   const handleViewAllNotes = () => {
//     navigate("/upload-notes/all-nios-notes");
//   };

//   const handleGoBack = () => {
//     navigate("/upload-notes/upload-all-notes");
//   };
//   return (
//     <>
//       <div id="exam-school-notes-inner-wrapper">
//         <div className="main-header">
//           <BiArrowBack
//             onClick={handleGoBack}
//             className="left-arrow-icon"
//             style={{
//               cursor: "pointer",
//               display: "flex",
//               fontSize: "25px",
//               color: "#000",
//             }}
//           />
//           <div className="exam-header-div">
//             <h5>Nios Notes</h5>
//             <div className="exam-btn-group">
//               <button className="addNewNoteBtn" onClick={handleAddNewNote}>
//                 + Upload Notes
//               </button>
//               <button className="viewAllNotesBtn" onClick={handleViewAllNotes}>
//                 All Notes
//               </button>
//             </div>
//           </div>

//           <div className="form-container" id="form">
//             <h4 className="note-detail">Note Details</h4>
//             <form onSubmit={handleSubmit} className="note-detail-form">
//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label">Class Name</label>
//                 </div>
//                 <select
//                   className="select-dropdown"
//                   value={schoolClassNameId}
//                   onChange={(e) => setSchoolClassNameId(e.target.value)}
//                   required
//                 >
//                   <option value="">-Select Class-</option>
//                   {schoolClassName &&
//                     schoolClassName.map((classes) => (
//                       <option value={classes._id} key={classes._id}>
//                         {classes?.className}
//                       </option>
//                     ))}
//                 </select>
//               </div>

//               <div className="new-chapter-form-group">
//                 <label className="new-chapter-label">Subject Name</label>
//                 <select
//                   className="new-chapter-dropdown"
//                   value={subjectId}
//                   onChange={(e) => setSubjectId(e.target.value)}
//                   required
//                 >
//                   <option value="">-Select Subject-</option>
//                   {subjects.map((subject, idx) => (
//                     <option key={idx} value={subject._id}>
//                       {subject.subjectName}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="input-group">
//                 <label className="label">Note Title</label>
//                 <input
//                   type="text"
//                   value={noteTitle}
//                   onChange={(e) => setNoteTitle(e.target.value)}
//                   placeholder="Enter Note Title"
//                   required
//                 />
//               </div>

//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label">Language</label>
//                   <input
//                     style={{ marginLeft: "10px" }}
//                     type="radio"
//                     value="hindi"
//                     checked={language === "hindi"}
//                     onChange={(e) => setLanguage(e.target.value)}
//                     required
//                   />
//                   Hindi
//                   <input
//                     style={{ marginLeft: "10px" }}
//                     type="radio"
//                     value="english"
//                     checked={language === "english"}
//                     onChange={(e) => setLanguage(e.target.value)}
//                     required
//                   />
//                   English
//                 </div>
//               </div>

//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label">Upload File (pdf format)</label>
//                 </div>
//                 <input
//                   type="file"
//                   onChange={(e) => setFile(e.target.files[0])} // Capture the file object
//                   accept=".pdf" // Restrict file type to PDF
//                   required
//                 />
//               </div>

//               <div className="form1-btns">
//                 <button className="btn-save">Save</button>
//                 <button
//                   type="button"
//                   className="btn-cancel"
//                   onClick={handleGoBack}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddNiosNotes;









import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AddNiosNotes = () => {

  const [schoolClassName, setSchoolClassName] = useState([]);
  const [schoolClassNameId, setSchoolClassNameId] = useState("");

  const [subjects, setSubjects] = useState([]);
  const [subjectId, setSubjectId] = useState("");

  const [noteTitle, setNoteTitle] = useState("");

  const [file, setFile] = useState(null);

  const [videoUrl, setVideoUrl] = useState(""); // ✅ added

  const [language, setLanguage] = useState("");

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const navigate = useNavigate();


  /* Fetch Classes */
  useEffect(() => {

    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {

        setSchoolClassName(resp.data);

      })
      .catch(console.log);

  }, []);


  /* Fetch Subjects */
  useEffect(() => {

    if (schoolClassNameId) {

      axios
        .get(`${API_BASE_URL}/niosSubjects?classId=${schoolClassNameId}`)
        .then((result) => {

          setSubjects(result.data);

        })
        .catch(console.log);

    }

  }, [schoolClassNameId]);


  /* Submit */
  const handleSubmit = (e) => {

    e.preventDefault();

    const formData = new FormData();

    formData.append("noteTitle", noteTitle);

    formData.append("language", language);

    formData.append("niosSubjectId", subjectId);

    formData.append("videoUrl", videoUrl); // ✅ added

    if (file) {
      formData.append("noteFile", file);
    }

    const role = localStorage.getItem("role");
    // decide endpoint based on role
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/notes`
        : `${API_BASE_URL}/admin/notes`;

    axios
      .post(
        endpoint,
        // `${API_BASE_URL}/admin/notes`,
         formData, {

        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },

      })
      .then(() => {

        alert("Nios Note / Video added successfully!");

        navigate("/upload-notes/all-nios-notes");

      })
      .catch((error) => {

        console.error(error);

        alert("There was an error adding the note.");

      });

  };


  /* Navigation handlers */
  const handleAddNewNote = () => {

    navigate("/upload-notes/add-nios-notes");

  };

  const handleViewAllNotes = () => {

    navigate("/upload-notes/all-nios-notes");

  };

  const handleGoBack = () => {

    navigate("/upload-notes/upload-all-notes");

  };


  return (

    <>

      <div id="exam-school-notes-inner-wrapper">

        <div className="main-header">

          {/* Back Arrow */}
          <BiArrowBack
            onClick={handleGoBack}
            className="left-arrow-icon"
            style={{
              cursor: "pointer",
              display: "flex",
              fontSize: "25px",
              color: "#000",
            }}
          />


          {/* Header */}
          <div className="exam-header-div">

            <h5>Nios Notes</h5>

            <div className="exam-btn-group">

              <button
                className="addNewNoteBtn"
                onClick={handleAddNewNote}
              >
                + Upload Notes
              </button>

              <button
                className="viewAllNotesBtn"
                onClick={handleViewAllNotes}
              >
                All Notes
              </button>

            </div>

          </div>


          {/* Form */}
          <div className="form-container" id="form">

            <h4 className="note-detail">
              Note Details
            </h4>


            <form
              onSubmit={handleSubmit}
              className="note-detail-form"
            >

              {/* Class */}
              <div className="input-group">

                <label className="label">
                  Class Name
                </label>

                <select
                  className="select-dropdown"
                  value={schoolClassNameId}
                  onChange={(e) =>
                    setSchoolClassNameId(e.target.value)
                  }
                  required
                >

                  <option value="">
                    -Select Class-
                  </option>

                  {schoolClassName.map((classes) => (

                    <option
                      value={classes._id}
                      key={classes._id}
                    >
                      {classes.className}
                    </option>

                  ))}

                </select>

              </div>


              {/* Subject */}
              <div className="new-chapter-form-group">

                <label className="new-chapter-label">
                  Subject Name
                </label>

                <select
                  className="new-chapter-dropdown"
                  value={subjectId}
                  onChange={(e) =>
                    setSubjectId(e.target.value)
                  }
                  required
                >

                  <option value="">
                    -Select Subject-
                  </option>

                  {subjects.map((subject) => (

                    <option
                      key={subject._id}
                      value={subject._id}
                    >
                      {subject.subjectName}
                    </option>

                  ))}

                </select>

              </div>


              {/* Title */}
              <div className="input-group">

                <label className="label">
                  Note Title
                </label>

                <input
                  type="text"
                  value={noteTitle}
                  onChange={(e) =>
                    setNoteTitle(e.target.value)
                  }
                  placeholder="Enter Note Title"
                  required
                />

              </div>


              {/* Language */}
              <div className="input-group">

                <label className="label">
                  Language
                </label>

                <div>

                  <input
                    type="radio"
                    value="hindi"
                    checked={language === "hindi"}
                    onChange={(e) =>
                      setLanguage(e.target.value)
                    }
                    required
                  />

                  Hindi

                  <input
                    style={{ marginLeft: "10px" }}
                    type="radio"
                    value="english"
                    checked={language === "english"}
                    onChange={(e) =>
                      setLanguage(e.target.value)
                    }
                    required
                  />

                  English

                </div>

              </div>


              {/* Video URL */}
              <div className="input-group">

                <label className="label">
                  Video URL
                </label>

                <input
                  type="text"
                  value={videoUrl}
                  onChange={(e) =>
                    setVideoUrl(e.target.value)
                  }
                  placeholder="Enter Video URL"
                />

              </div>


              {/* File Upload */}
              <div className="input-group">

                <label className="label">
                  Upload File (pdf format)
                </label>

                <input
                  type="file"
                  accept=".pdf"
                  onChange={(e) =>
                    setFile(e.target.files[0])
                  }
                />

              </div>


              {/* Buttons */}
              <div className="form1-btns">

                <button className="btn-save">
                  Save
                </button>

                <button
                  type="button"
                  className="btn-cancel"
                  onClick={handleGoBack}
                >
                  Cancel
                </button>

              </div>

            </form>

          </div>

        </div>

      </div>

    </>

  );

};

export default AddNiosNotes;
